<template>
   <form action="/gallery/save" class="dropzone" id="my-great-dropzone">
    </form>
</template>

<script>

export default {

    mounted(){
        Dropzone.options.myGreatDropzone = { // camelized version of the `id`
            paramName: "file", // The name that will be used to transfer the file
            maxFilesize: 2, // MB
            acceptedFiles: 'image/*',
            dictCancelUpload: "Przesyłanie anulowane.",
            dictCancelUploadConfirmation: "Are you sure you want to cancel this upload?",
            dictDefaultMessage: "Upuść pliki tutaj, aby przesłać",
            dictFallbackMessage: "Twoja przeglądarka nie obsługuje przesyłania plików metodą drag'n'drop.",
            dictFallbackText: "Skorzystaj z poniższego formularza rezerwowego, aby przesłać pliki tak, jak za dawnych czasów.",
            dictFileTooBig: "Plik jest za duży ({{filesize}} MiB). Maksymalny rozmiar pliku: {{maxFilesize}} MiB.",
            dictInvalidFileType: "Nie możesz przesyłać plików tego typu.",
            dictMaxFilesExceeded: "Nie możesz przesłać więcej plików.",
            dictRemoveFile: "Usuń plik.",
            dictResponseError: "Serwer odpowiedział kodem {{statusCode}}.",
            dictUploadCanceled: "Przesyłanie anulowane.",

            accept: function(file, done) {
                if(file.type != 'image/jpeg' && file.type != 'image/png')
                {
                    done("Błąd! Plik tego typu nie jest akceptowalny!");
                }
                else done();
            },
            queuecomplete: function(){
                _this.fetchData();
                let drop = this;

                setTimeout(function(){
                    drop.removeAllFiles();
                }, 3000)
            }
        };
    }
}
</script>
